import React from 'react';
import './App.css';
import 'pretty-checkbox';


import Nav from './components/Nav'
import RightNav from './components/RightNav'
import Feed from './components/Feed'

function App() {
  return (
    <div className="app">
      <Nav />
      <div className="feed">
        <Feed />
      </div>
      <RightNav />
    </div>
  );
}

export default App;
